import { useState } from 'react';

export type SortDirection = 'asc' | 'desc';

export const useAPIOrdering = (
    defaultSortField: string,
    initialOrderForDefaultField: SortDirection = 'asc'
) => {
    const [orderMap, setOrderMap] = useState<Record<string, SortDirection>>({
        [defaultSortField]: initialOrderForDefaultField
    });
    const [sortField, setSortField] = useState<string>(defaultSortField);

    const handleRequestSort = (field: string) => {
        const currentOrder = orderMap[field] || 'asc';
        const newOrder: SortDirection = currentOrder === 'asc' ? 'desc' : 'asc';
        setOrderMap((prev) => ({ ...prev, [field]: newOrder }));
        setSortField(field);
    };

    const sortDirection = orderMap[sortField] || 'asc';

    return {
        sortDirection,
        sortField,
        handleRequestSort,
        orderMap
    };
};
